import React, { useState } from "react";
import Widget from "components/Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import FormsSettings from "../WidgetsSettings/FormV3/FormSettingsModal";
import FormV3Controller from "./FormV3Controller";

const FormV3Widget = ({ value, role }) => {
   const [isSettingsOpen, setIsSettingsOpen] = useState(false);

   return (
      <Widget
         bgColor={value.backgroundColourHex}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={value.name}
                  widgetId={value.id}
                  icon="setting"
                  deleteIcon="true"
                  isOpen={isSettingsOpen}
                  setIsOpen={setIsSettingsOpen}
                  children={
                     <FormsSettings value={value} onPreview={() => setIsSettingsOpen(false)} />
                  }
               />
            )
         }
      >
         <FormV3Controller formId={value.formId} dataId={value.dataId}></FormV3Controller>
      </Widget>
   );
};

export default FormV3Widget;
